import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: "02a6880e-1c1c-4ba9-80d5-41cd4b027cdf",
    authority: "https://login.microsoftonline.com/dbc2add5-d0e7-4f09-8b10-7b58a23e15af",
    redirectUri: "https://gexonline.gexpertise.fr/carte",
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
